import React from 'react';
import { getGroupInterest } from './utils/groupCalculation';

const GroupInterest = React.memo(({ positionList }) => {
    const totalInterest = getGroupInterest(positionList);
    return <div>{totalInterest.toFixed(2)}</div>;
});
// const GroupInterest = React.memo(({ positionList }) => {
//     const totalInterest = positionList.reduce((total, pos) => total + (pos.interest ?? 0), 0);
//     return <div>{totalInterest.toFixed(2)}</div>;
// });

export default GroupInterest;
